import { Injectable } from '@angular/core';
import { ApiService } from './api.services';
import { Client } from '../models/client';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
	providedIn: 'root',
})
export class ClientDetailsService {
	private client?: Client;

	constructor(private readonly apiService: ApiService) {}

	public async getClientDetails(
		clientId: string,
		isUpdated?: boolean
	): Promise<Client> {
		if (!this.client || this.client.id !== clientId || isUpdated) {
			this.client = await this.apiService.getClientDetails(clientId);
		}

		return this.client;
	}

	public async saveClientDetails(client: Client): Promise<void> {
		this.client = client;
	}
}
